import AppPointRiverBase from '@/components/AppPoint/RiverBasePC';
import OtherList from '@/components/ProductCommon/OtherList';
import EFVideo from '@/components/UI/EFVideo';
import Image from '@/components/UI/Image';
import { SHOW_APP_POINT_SITES } from '@/constants';
import { getDetaileMoreProducts, intlNumber } from '@/utils';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { Tabs } from 'antd';
import { TimelineMax, TweenMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

const { TabPane } = Tabs;
const { EFPic } = createEFPic('/media/riverpro/pc/');
const EfImage = Image;
export default function IndexDynamic() {
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const { useState, useEffect, gloproductlist, useRef, useLang, useRouter, Link } = useGlobal();
    const videoRef2 = useRef(null);
    const { t } = useLang('riverproportablepowerstation');
    const { locale } = useRouter();
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);

    const otherProductData = getDetaileMoreProducts(gloproductlist, ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max']);
    const [processNumber, setProcessNumber] = useState(0);
    const videoMap: any = {
        us: {
            kv: ['/video/riverpro/kv.webm', '/video/riverpro/kv.mp4'],
            number: ['/video/riverpro/number.webm', '/video/riverpro/number.mp4'],
        },
        au: {
            kv: ['/video/riverpro/kv_au.webm', '/video/riverpro/kv_au.mp4'],
            number: ['/video/riverpro/number_au.webm', '/video/riverpro/number_au.mp4'],
        },
        uk: {
            kv: ['/video/riverpro/kv_uk.webm', '/video/riverpro/kv_uk.mp4'],
            number: ['/video/riverpro/number_uk.webm', '/video/riverpro/number_uk.mp4'],
        },
        de: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        fr: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        cn: {
            kv: ['/video/riverpro/kv_cn.webm', '/video/riverpro/kv_cn.mp4'],
            number: ['/video/riverpro/number_cn.webm', '/video/riverpro/number_cn.mp4'],
        },
        it: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        es: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        eu: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        za: {
            kv: ['/video/riverpro/kv_za.webm', '/video/riverpro/kv_za.mp4'],
            number: ['/video/riverpro/number_za.webm', '/video/riverpro/number_za.mp4'],
        },
        sa: {
            kv: ['/video/riverpro/kv_uk.webm', '/video/riverpro/kv_uk.mp4'],
            number: ['/video/riverpro/number_uk.webm', '/video/riverpro/number_uk.mp4'],
        },
    };

    const currentVideo = locale in videoMap ? videoMap[locale] : videoMap.us;

    const isAr = locale == 'sa';
    const getFinalUnit = (baseUnit: string, arabUnit: string) => {
        return isAr ? arabUnit : baseUnit;
    };

    useEffect(() => {
        // if (tabsel !== 'Overview') {
        //     return;
        // }
        const controller = new ScrollMagic.Controller();

        // 数字翻滚动画
        const sceneDigital = new ScrollMagic.Scene({
            triggerElement: '.digital-block',
            offset: -0.2 * layoutH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '10%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenDigital = TweenMax.to('.digital-block', 0.1, {});
        sceneDigital.on('enter', () => {
            if (videoRef2.current) {
                videoRef2.current.play();
            }
        });

        sceneDigital.on('leave', () => (videoRef2.current = null));
        sceneDigital.setTween(tweenDigital);
        controller.addScene(sceneDigital);

        // 卡片微调动画
        const sceneCard = new ScrollMagic.Scene({
            triggerElement: '.card1 .img-bottom',
            offset: 50, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '150%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenCard = TweenMax.to('.img-bottom', 0.5, {
            y: -218,
        });
        sceneCard.setTween(tweenCard);
        controller.addScene(sceneCard);

        const sceneProcess = new ScrollMagic.Scene({
            triggerElement: '.process-module',
            offset: -100, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenProcess2 = TweenMax.to('.process-module .process-line-top', 1, {
            width: '1120px',
            ease: 'none',
        });
        const tweenProcess3 = TweenMax.to('.process-module .process-line-bottom', 1, {
            width: '1120px',
            ease: 'none',
        });
        const tweenProcess4 = TweenMax.to('.process-module .process-line-left-triangle', 0.05, {
            opacity: 1,
        });
        const tweenProcess5 = TweenMax.to('.process-module .process-line-bottom-text', 0.05, {
            opacity: 1,
        });
        const tweenProcess6 = TweenMax.to('.process-module .process-text-left', 0.075, {
            y: -528,
            opacity: 0,
        });
        const tweenProcess7 = TweenMax.to('.process-module .process-text-right', 0.075, {
            opacity: 1,
            height: '648px',
            y: -40,
        });
        const tweenProcess8 = TweenMax.to('.process-module .process-text-right', 0.05, {
            y: -60,
            opacity: 0,
        });
        const tweenProcess9 = TweenMax.to('.process-module .process-text-tab', 0.1, {
            y: -70,
            opacity: 1,
            zIndex: 22,
        });
        const tweenProcess10 = TweenMax.to('.process-module .process-line-right-triangle', 0.05, {
            opacity: 1,
        });

        const finalValue = 600;
        sceneProcess.on('progress', (self: any) => {
            const progress = self.progress;
            // console.log('progress', progress);
            setProcessNumber(() => Math.min(Math.round(progress * (finalValue + 100)), finalValue));
        });
        const timelineProcess = new TimelineMax();
        timelineProcess
            .add(tweenProcess2, 0)
            .add(tweenProcess3, 0)
            .add(tweenProcess4, 0)
            .add(tweenProcess5, 0)
            .add(tweenProcess6, 0.5)
            .add(tweenProcess7, 0.5)
            .add(tweenProcess8, 1)
            .add(tweenProcess9, 1)
            .add(tweenProcess10, 1);

        sceneProcess.setTween(timelineProcess);
        controller.addScene(sceneProcess);

        // 卡片翻滚动画
        const sceneSlideCard = new ScrollMagic.Scene({
            triggerElement: '.charge-module',
            offset: -0.3 * layoutH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenSlideCard1 = TweenMax.to('.ci2', 0.06, {
            opacity: 1,
        });
        const tweenSlideCard2 = TweenMax.to('.ci2', 0.3, {
            y: -670,
        });
        const tweenSlideCard22 = TweenMax.to('.ci3', 0.2, {
            y: -300,
        });
        const tweenSlideCard3 = TweenMax.to('.ci1 .charge-item-img', 0.15, {
            opacity: 0.72,
        });
        const tweenSlideCard4 = TweenMax.to('.ci1 .charge-item-img', 0.1, {
            scale: 0.86,
            y: -20,
        });
        const tweenSlideCard5 = TweenMax.to('.ci1 .charge-item-text', 0.1, {
            opacity: 0,
        });
        const tweenSlideCard6 = TweenMax.to('.ci2 .charge-item-text', 0.15, {
            opacity: 0,
            y: -20,
        });
        const tweenSlideCard77 = TweenMax.to('.ci3', 0.06, {
            opacity: 1,
        });
        const tweenSlideCard7 = TweenMax.to('.ci3', 0.8, {
            y: -969,
        });
        const tweenSlideCard8 = TweenMax.to('.ci2 .charge-item-img', 0.2, {
            scale: 0.85,
            opacity: 0.75,
            y: -62,
        });
        const tweenSlideCard9 = TweenMax.to('.ci1 .charge-item-img', 0.2, {
            opacity: 0,
            scale: 0.7,
            y: -60,
        });

        const tweenSlideCard10 = TweenMax.to('.charge-module .sticky-box', 0.2, {
            height: 900,
        });

        const timelineSlideCard = new TimelineMax();
        timelineSlideCard
            .add(tweenSlideCard1)
            .add(tweenSlideCard2, 0.03)
            .add(tweenSlideCard22, 0.03)
            .add(tweenSlideCard3, 0.09)
            .add(tweenSlideCard4, 0.09)
            .add(tweenSlideCard5, 0.08)
            .add(tweenSlideCard6, 0.3)
            .add(tweenSlideCard77, 0.28)
            .add(tweenSlideCard7, 0.3)
            .add(tweenSlideCard8, 0.3)
            .add(tweenSlideCard9, 0.32)
            .add(tweenSlideCard10, 0.9);

        sceneSlideCard.setTween(timelineSlideCard);
        controller.addScene(sceneSlideCard);

        // Peace of mind module
        const sceneScale = new ScrollMagic.Scene({
            triggerElement: '.scale-module',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timelineScale = new TimelineMax();

        const tweenScale1 = TweenMax.to('.scale-module', 0.5, {
            width: 1440,
            borderRadius: 60,
        });
        const tweenScale2 = TweenMax.to('.scale-module .scale-text-wrapper', 0.4, {
            opacity: 1,
        });
        timelineScale.add(tweenScale1).add(tweenScale2, 0.1);
        sceneScale.setTween(timelineScale);
        controller.addScene(sceneScale);
    }, []);

    const [isLeft, setIsLeft] = useState(true);
    const changeTab = (activeKey: string) => setIsLeft(activeKey === '1');

    return (
        <>
            <div className="section2">
                <div className="top">
                    <div className="tl box">
                        <EFPic
                            name={['RIVER PRO_web_1.webp', 'RIVER PRO_web_1.png']}
                            alt={t('river_pro.image.Capacity')}
                            aria-label={t('river_pro.image.Capacity')}
                        />
                        <p className="tit">{t('river_pro.image.Capacity')}</p>
                    </div>
                    <div className="tr box">
                        <div className="trt box">
                            <EFPic
                                name={['RIVER PRO_web_4.webp', 'RIVER PRO_web_4.png']}
                                alt={t('river_pro.image.X-Stream-pc')}
                                aria-label={t('river_pro.image.X-Stream-pc')}
                            />
                            <p className="tit">{t('river_pro.image.X-Stream-pc')}</p>
                        </div>
                        <div className="trb box">
                            <EFPic
                                name={['RIVER PRO_web_5.webp', 'RIVER PRO_web_5.png']}
                                alt={t.rich('river_pro.image.Up to')}
                                aria-label={t.rich('river_pro.image.Up to')}
                            />
                            <div className="tit">
                                {t.rich('river_pro.image.Up to', {
                                    line: (text: any) => <p className="num">{text}</p>,
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="bl box">
                        <EFPic
                            name={['RIVER PRO_web_2.webp', 'RIVER PRO_web_2.png']}
                            alt={t('river.ytdd_section2_tit')}
                            aria-label={t('river.ytdd_section2_tit')}
                        />
                        <p className="tit">{t('river_pro.image.AC Output')}</p>
                        <p className="num">{t('river_pro.image.600W')}</p>
                    </div>
                    <div className="bm box">
                        <EFPic
                            name={['RIVER PRO_web_3.webp', 'RIVER PRO_web_3.png']}
                            alt={t('river_pro.image.X-Boost-pc')}
                            aria-label={t('river_pro.image.X-Boost-pc')}
                        />
                        <p className="tit">
                            {t('river_pro.image.X-Boost-pc')} {t('river_pro.image.1800W')}
                        </p>
                    </div>
                    <div className="br box">
                        <EFPic
                            name={['RIVER PRO_web_6.webp', 'RIVER PRO_web_6.png']}
                            alt={t('river_pro.image.App Control')}
                            aria-label={t('river_pro.image.App Control')}
                        />
                        <p className="tit">{t('river_pro.image.App Control')}</p>
                    </div>
                </div>
            </div>
            <div className="digital-block">
                <div className="text-title">{t('river_pro.EC')}</div>
                <div className="canvas-box">
                    <EFVideo ref={videoRef2} sources={currentVideo.number} width="100%" height="100%" className="fullImgs" autoPlay={false} loop={false} />
                </div>
            </div>
            <div className="card card1">
                <div className="text-title">{t('river_pro.PFTLH')}</div>
                <div className="animate-canvas">
                    <div className="text-left">{t('river_pro.PFTLH_desc')}</div>
                    <div className="img-right">
                        <EFPic name={['haul_right.webp', 'haul_right.png']} className="fullImgs" alt="product description" />
                    </div>
                    <div className="img-bottom">
                        <EFPic name={[`haul_bottom_${imgSpec}.webp`, `haul_bottom_${imgSpec}.png`]} className="fullImgs" alt="product description" />
                    </div>
                </div>
            </div>
            <div className="process-module">
                <div className="sticky-box">
                    <div className="process-line">
                        <div className="process-line-top"></div>
                        <div className="process-line-bottom">
                            <div className="process-line-bottom-text">
                                <p className="process-line-bottom-line1">{t('river_pro.image.AC Output')}</p>
                                <p className="process-line-bottom-line2">{processNumber}W</p>
                            </div>
                            <div className="process-line-right-triangle">
                                <div className="process-line-right-triangle-item"></div>
                            </div>
                        </div>
                        <div className="process-text-left">
                            <div className="process-text-left-title">{t('river_pro.MPTY')}</div>
                            <div className="process-text-left-desc">
                                {t.rich('river_pro.MPTY_desc', {
                                    line1: (text: string) => (
                                        <Link className="ef-link__page" href="/x-boost" newWin>
                                            {text}
                                        </Link>
                                    ),
                                })}
                            </div>
                        </div>
                        <div className="process-text-right">
                            <EFPic name={['process.webp', 'process.jpg']} layout="fill" className="fullImgs" />
                        </div>
                        <div className={`process-text-tab ${isLeft ? 'is-left' : 'is-right'}`}>
                            <Tabs defaultActiveKey="1" onChange={changeTab}>
                                <TabPane tab={t('river_pro.HB')} key="1">
                                    <div className="process-text-tab-content">
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/homebackup/light.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Light')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 65.2)}
                                                <span className="suffix">{getFinalUnit(t('Hrs'), t('river_pro.Hrs4'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/homebackup/refrigerator.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Refrigerator')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 4.5)}
                                                <span className="suffix">{getFinalUnit(t('Hrs'), t('river_pro.Hrs4'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/homebackup/blender.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Blender')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 1.2)}
                                                <span className="suffix">{getFinalUnit(t('Hrs'), t('river_pro.Hrs4'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/homebackup/tv.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.50 TV')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                5<span className="suffix">{getFinalUnit(t('Hrs'), t('river_pro.Hrs3'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/homebackup/hairdryer.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Hair Dryer')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 0.7)}
                                                <span className="suffix">{getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('river_pro.Hrs4'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/homebackup/coffeemaker.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Coffee Maker')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 0.7)}
                                                <span className="suffix">{getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('river_pro.Hrs4'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/homebackup/projector.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Projector')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                8<span className="suffix">{getFinalUnit(t('Hrs'), t('river_pro.Hrs3'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                    </div>
                                </TabPane>
                                <TabPane tab={t('river_pro.OG')} key="2">
                                    <div className="process-text-tab-content">
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/offgrid/phone.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Phone')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                59<span className="suffix">{getFinalUnit(t('Times'), t('river_pro.Times1'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/offgrid/laptop.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Laptop')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                10<span className="suffix">{getFinalUnit(t('Times'), t('river_pro.Times3'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/offgrid/camera.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Camera')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                40<span className="suffix">{getFinalUnit(t('Times'), t('river_pro.Times1'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/offgrid/speaker.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Speaker')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 22.2)}
                                                <span className="suffix">{getFinalUnit(t('Hrs'), t('river_pro.Hrs1'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/offgrid/drones.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Drone')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                16<span className="suffix">{getFinalUnit(t('Times'), t('river_pro.Times1'))}</span>
                                            </p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/offgrid/electrickettle.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Electric Kettle')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 0.7)}
                                                <span className="suffix">{getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('river_pro.Hrs1'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/offgrid/electricfryingpan.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname overlength">{t('river_pro.Electric Frying Pan')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 0.7)}
                                                <span className="suffix">{getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('river_pro.Hrs1'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                        <div className="process-text-tab-item">
                                            <div className="img-wrapper">
                                                <EfImage src={'/media/riverpro/pc/offgrid/ricecooker.svg'} layout="fill" className="fullImgs"></EfImage>
                                            </div>
                                            <p className="process-text-tab-itemname">{t('river_pro.Rice Cooker')}</p>
                                            <p className="process-text-tab-itemnumber">
                                                {intlNumber(locale, 0.7)}
                                                <span className="suffix">{getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('river_pro.Hrs1'))}</span>
                                            </p>
                                            <p></p>
                                        </div>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                        <div className="process-line-left-triangle">
                            <div className="process-line-left-triangle-item"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="charge-module">
                <div className="sticky-box">
                    <div className="charge-text-title">{t('river_pro.Charging')}</div>
                    <div className="charge-item ci1">
                        <div className="charge-item-img">
                            <EFPic name={['charge1.webp', 'charge1.png']} className="fullImgs" alt="product description" />
                        </div>
                        <div className="charge-item-text">
                            <div className="charge-item-text-icon"></div>
                            {t.rich('river_pro.ITWF', {
                                line1: (child: any) => <div className="charge-item-text-title charge-item-text-line1">{child}</div>,
                                line2: (child: any) => <div className="charge-item-text-title purple">{child}</div>,
                                line3: (child: any) => <div className="charge-item-text-title purple charge-item-text-line2">{child}</div>,
                            })}
                            <div className="charge-item-text-desc">
                                {t.rich('river_pro.ITWF_desc', {
                                    line1: (text: string) => (
                                        <Link className="ef-link__page" href="/x-stream" newWin>
                                            {text}
                                        </Link>
                                    ),
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="charge-item ci2">
                        <div className="charge-item-img">
                            <EFPic name={['charge2.webp', 'charge2.png']} className="fullImgs" alt="product description" />
                        </div>
                        <div className="charge-item-text">
                            {t.rich('river_pro.SPGOGIE', {
                                line1: (child: any) => <div className="charge-item-text-small">{child}</div>,
                                line2: (child: any) => <div className="charge-item-text-title">{child}</div>,
                                line3: (child: any) => <div className="charge-item-text-title">{child}</div>,
                                line4: (child: any) => <div className="charge-item-text-title orange">{child}</div>,
                            })}
                            <div className="charge-item-text-desc">{t('river_pro.SPGOGIE_desc')}</div>
                        </div>
                    </div>
                    <div className="charge-item ci3">
                        <div className="charge-item-img">
                            <EFPic name={[`charge3_${imgSpec}.webp`, `charge3_${imgSpec}.png`]} className="fullImgs" alt="product description" />
                        </div>
                        <div className="charge-item-text">
                            <p className="charge-item-text-plain">{t('river_pro.CO')}</p>
                            <div className="charge-item-text-desc">{t('river_pro.CO_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="scale-module">
                <div className="bgImg">
                    <EFPic name={['scale.webp', 'scale.jpg']} />
                </div>
                <div className="content-box">
                    <div className="scale-text-wrapper">
                        <div className="scale-text-title">{t('river_pro.POM')}</div>
                        <div className="scale-text-desc">{t('river_pro.POM_desc')}</div>
                    </div>
                </div>
            </div>
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <div className="life-module">
                    <div className="bgImg">
                        <EFPic name={[`9_main_${appImgLocal}.webp`, `9_main_${appImgLocal}.png`]} />
                    </div>
                    <div className="text-wrapper">
                        {t.rich('river_pro.FLOTG', {
                            line1: (child: any) => <div className="lift-module-text">{child}</div>,
                            line2: (child: any) => <div className="lift-module-text">{child}</div>,
                        })}
                    </div>
                    <div className="life-module-desc">{t('river_pro.FLOTG_desc')}</div>
                </div>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverBase />}
            <OtherList data={otherProductData} />
        </>
    );
}
